/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { ReactComponent as CloseButton } from '../../../icons/blue-close-button-icon.svg';
import BlueButton from '../../blueButton';
import RedButton from '../../redButton';
import { Container, PopUp } from './styles';
import Input from '../../Form/input';
import api from '../../../services/api';
import Delete from '../../DeletePopUp';
import ApprovePopUp from '../../ApprovePopUp';

import { useError } from '../../../hooks/errors';

type popUpProp = {
  setPopUpState: any;
  isOpen: boolean;
  rowData?: string[] | any;
};

RedePopUp.defaultProps = {
  rowData: false,
};

export default function RedePopUp({
  isOpen,
  setPopUpState,
  rowData,
}: popUpProp) {
  const { emitError } = useError();
  const popUpRef = useRef(null);
  const formRef = useRef(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deletePdv, setDeletePdv] = useState(false);

  const handleClick = (e: MouseEvent) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,@typescript-eslint/no-non-null-asserted-optional-chain
    if ((popUpRef?.current! as any)?.contains(e?.target)) {
      return;
    }
    setPopUpState(false);
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [isOpen]);

  async function handleDelete() {
    try {
      await api.delete(`/networks/${rowData.id}`);
      toast.success('Rede deletado');
      window.location.reload();
    } catch (error: any) {
      toast.error('Rede referenciado por outra tabela');
    }
  }

  async function handlePut(data: any) {
    try {
      const schema = Yup.object().shape({
        name: Yup.string().required('O nome da rede é obrigatório'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.put(`/networks/${rowData.id}`, data);
      window.location.reload();
    } catch (error: any) {
      if (error instanceof Yup.ValidationError) {
        emitError({}, 'Preencha os campos obrigatórios!');
        setShowConfirmation(false);

        const errorMessages = {};
        error.inner.forEach(err => {
          errorMessages[err.path] = err.message;
        });

        formRef.current.setErrors(errorMessages);
      }
    }
  }

  async function handlePost(data: any) {
    try {
      const schema = Yup.object().shape({
        name: Yup.string().required('O nome da rede é obrigatório'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post('/networks', data);
      window.location.reload();
    } catch (error: any) {
      if (error instanceof Yup.ValidationError) {
        emitError({}, 'Preencha os campos obrigatórios!');
        setShowConfirmation(false);

        const errorMessages = {};
        error.inner.forEach(err => {
          errorMessages[err.path] = err.message;
        });

        formRef.current.setErrors(errorMessages);
      }
    }
  }

  const initialData = {
    name: rowData.name,
  };

  return (
    <Container>
      <PopUp ref={popUpRef}>
        {deletePdv ? (
          <Delete
            title="Rede"
            isOpen={deletePdv}
            setCustomState={handleDelete}
            setPopUpState={setDeletePdv}
          />
        ) : null}

        <div className="pop-up-header">
          <p>Rede</p>

          <button type="button" onClick={() => setPopUpState(!isOpen)}>
            <CloseButton />
          </button>
        </div>
        <Form
          ref={formRef}
          onSubmit={rowData ? handlePut : handlePost}
          initialData={rowData ? initialData : null}
        >
          <label htmlFor="name">
            Nome
            <span style={{ display: 'inline', color: 'red' }}> *</span>
          </label>

          {rowData !== false ? (
            <Input name="name" id="name" />
          ) : (
            <Input name="name" id="name" placeholder="Nome" />
          )}

          {!rowData ? (
            <div className="button-field">
              <BlueButton
                title="salvar"
                setCustomState={setShowConfirmation}
                customState={showConfirmation}
              />

              <button
                type="button"
                className="cancel-button"
                onClick={() => setPopUpState(!isOpen)}
              >
                Cancelar
              </button>
            </div>
          ) : null}

          {rowData ? (
            <div className="edit-pdv">
              <RedButton
                title="Apagar"
                setCustomState={setDeletePdv}
                customState={deletePdv}
              />
              <BlueButton
                title="Editar"
                setCustomState={setShowConfirmation}
                customState={showConfirmation}
              />
            </div>
          ) : null}

          {showConfirmation ? (
            <ApprovePopUp
              sampleText="Adicionar Rede?"
              isOpen={showConfirmation}
              setPopUpState={setShowConfirmation}
            />
          ) : null}
        </Form>
      </PopUp>
    </Container>
  );
}
